import { FormGroup, AbstractControl, FormArray } from '@angular/forms';

export class FormGroupHelperService {
  public markAllAsTouched(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.controls[controlName] as AbstractControl;
      formGroup.controls[controlName].markAsTouched();

      if (control instanceof FormGroup) {
        this.markAllAsTouched(control);
      }
    });
  }

  public markAllFormArrayControlsAsDirty(form: FormGroup | FormArray): void {
    form.markAsDirty();
    Object.keys(form.controls).forEach((key: string) => {
      const control = form.get(key);

      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markAllFormArrayControlsAsDirty(control);
      } else {
        control?.markAsDirty();
      }
    });
  }

  public markAllAsDirty(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.controls[controlName] as AbstractControl;
      formGroup.controls[controlName].markAsDirty();

      if (control instanceof FormGroup) {
        this.markAllAsDirty(control);
      }
    });
  }

  public updateValueAndValidityForAll(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.controls[controlName] as AbstractControl;
      formGroup.controls[controlName].updateValueAndValidity();

      if (control instanceof FormGroup) {
        this.updateValueAndValidityForAll(control);
      }
    });
  }
}
